import { RegionShared } from "@1games-ru/region-shared";
import { useTranslation } from "react-i18next";
import { Mask2Icon } from "@/shared/icons";
import {
  CHILD_CIRCLE_CENTER_X,
  CHILD_CIRCLE_CENTER_Y,
  CHILD_CIRCLE_INNER_RADIUS,
  CIRCLE_GAP,
} from "@/domains/targetMenu/constants/TargetMenuCircle";
import describeSector from "@/domains/targetMenu/helpers/describeSector";
import iconDict from "@/domains/targetMenu/helpers/iconDict";

type Props = {
  parentSize: number;
  parentStartAngle: number;
  items: (typeof RegionShared.Types.TargetMenu.MenuItem)[];
  onClick: (item: typeof RegionShared.Types.TargetMenu.MenuItem) => void;
};

function TargetMenuChildren({ parentSize, parentStartAngle, items, onClick }: Props) {
  const { t } = useTranslation("targetMenu");

  return (
    <div>
      {items.map((item, index) => {
        const outerRadius = CHILD_CIRCLE_CENTER_X;
        const totalChildren = items.length;
        const childsSize = (360 / 16) * items.length;

        const size = childsSize / totalChildren;

        const midParentAngleSector = parentStartAngle + parentSize / 2;

        const startAngle = midParentAngleSector - childsSize / 2 + size * index;

        const endAngle = startAngle + size;

        const commonData = {
          x: CHILD_CIRCLE_CENTER_X,
          y: CHILD_CIRCLE_CENTER_Y,
          startAngle,
          endAngle,
        };

        // разметка секторов
        const shapePath = describeSector({
          ...commonData,
          r: CHILD_CIRCLE_INNER_RADIUS,
          r2: outerRadius,
          gap: 0.0001,
        });

        // видимая область сектора
        const fillPath = describeSector({
          ...commonData,
          r: CHILD_CIRCLE_INNER_RADIUS,
          r2: outerRadius,
          gap: 1.1,
        });

        // внутренний сектор для градиента белого или красного
        const innerSectorPath = describeSector({
          ...commonData,
          r: CHILD_CIRCLE_INNER_RADIUS + CIRCLE_GAP,
          r2: outerRadius - CIRCLE_GAP,
          gap: CIRCLE_GAP * 0.3,
        });

        // красная линия при наведении
        const strokePath = describeSector({
          ...commonData,
          r: CHILD_CIRCLE_INNER_RADIUS + 0.75 * CIRCLE_GAP,
          r2: CHILD_CIRCLE_INNER_RADIUS + 1.5 * CIRCLE_GAP,
          gap: CIRCLE_GAP * 0.3,
        });

        const angle = startAngle + (endAngle - startAngle) / 2 - 90;

        const Icon =
          (item.eventName && iconDict[item.eventName]
            ? iconDict[item.eventName]
            : iconDict[item.name]) || Mask2Icon;

        return (
          <div
            key={item.name}
            className="circular-menu-sector circular-menu-sector--child"
            style={
              {
                "--inner-sector-path": `path('${innerSectorPath}')`,
                "--angle-sin": `${Math.sin(angle * (Math.PI / 180))}`,
                "--angle-cos": `${Math.cos(angle * (Math.PI / 180))}`,
                "--angle-sin-count-number": `${Math.sin((angle + 2.3 * size) * (Math.PI / 180))}`,
                "--angle-cos-count-number": `${Math.cos((angle + 2.3 * size) * (Math.PI / 180))}`,
                "--shape-path": `path('${shapePath}')`,
                "--fill-path": `path('${fillPath}')`,
                "--stroke-path": `path('${strokePath}')`,
                // "--rotate": `${rotate}deg`,
              } as React.CSSProperties
            }
          >
            <button
              type="button"
              className="circular-menu-sector-btn"
              onClick={() => {
                onClick(item);
              }}
            >
              <span className="circular-menu-sector-btn-inner">
                <Icon />
                <span className="capitalize">{t(`targetMenu.${item.name}`)}</span>
              </span>
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default TargetMenuChildren;
